import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect } from "react";

export default function Confirm({
  content,
  active = false,
  onCancel = false,
  cancelButton = true,
  callback,
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (active) onOpen();
  }, [active, onOpen]);

  function close() {
    if (onCancel) onCancel();
    onClose();
  }

  function submit() {
    callback();
    onClose();
  }

  return (
    <Modal
      blockScrollOnMount={true}
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={close}
    >
      <ModalOverlay />
      <ModalContent maxWidth={350} alignItems="center">
        <ModalHeader textAlign="center">{content.title}</ModalHeader>
        {cancelButton && <ModalCloseButton />}
        <ModalBody>
          <Text textAlign="center" style={{ whiteSpace: "pre-wrap" }}>
            {content.desc}
          </Text>
        </ModalBody>

        <ModalFooter>
          {cancelButton && (
            <Button onClick={close} mr={3}>
              Tidak
            </Button>
          )}
          <Button colorScheme="blue" onClick={submit}>
            Ya
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
